<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'Product Point'"
          :fields="fields"
          :items="data"
          :editButton="(acceptanceStatus.includes(productStatus)) ? true : false"
          :redirectDetail="false"
          :enableAddButton="false"
          :isLoading="isLoading"
          :withCard="false"
          @editForm="editForm"
        ></GlobalTable>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <CInput
              type="number"
              label="Points"
              invalid-feedback="Points should be filled"
              required
              v-model="$v.productPointForm.points.$model"
              :is-valid="!$v.productPointForm.points.$invalid"
            />
          </CCol>
          <CCol sm="3">
            <CInput
              type="number"
              label="Referal"
              invalid-feedback="Referal should be filled"
              required
              v-model="$v.productPointForm.referal.$model"
              :is-valid="!$v.productPointForm.referal.$invalid"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.productPointForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../../templates/Loading";
import GlobalTable from "../../../../templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "ProductPoint",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Price",
      items: [],
      addButton: false,
      isEdit: false,
      productPointForm: tableInterfaces.product_point,
      isLoading: false,
      image: null,
      activeTab: 0,
      checkedFlag: "Agent",
      fields: [
        { key: "points", label: "Point Product", sorter: true },
        { key: "referal", label: "Point Referal Product", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      options: [
        { value: "1", label: "Konsumen" },
        { value: "2", label: "Seller" },
      ],
      acceptanceStatus: ['2','7']
    };
  },
  props: {
    products: {
      type: [Array, Object],
      default: () => [],
    },
    points: {
      type: [Array, Object],
      default: () => [],
    },
    productStatus: {
      type: String,
      default: null,
    },
  },
  validations: {
    productPointForm: {
      points: { required },
      product_code: {},
      referal: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function() {
      return (this.items.length > 0) ? this.items: this.points;
    }
  },
  methods: {
    init: function () {},
    refreshPoint: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/product_point/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.isEdit = true;
      console.log(item);
      this.productPointForm = item;
      this.addButton = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.product_point) {
        tableInterfaces.product_point[i] = null;
      }
      this.productPointForm = tableInterfaces.product_point;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.productPointForm.product_code = this.products.product_code;
      this.productPointForm.flag = 1;
      if (confirm("Do you want to change this data ?")) {
        this.isLoading = true;
        this.axios
          .put("console/product_point/update", this.productPointForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshPoint(this.products.id);
          });
      }
    },
  },
  mounted() {},
};
</script>
